"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("configs/routes/constants");
const ModuleTypes_1 = require("./ModuleTypes");
class PageUtil {
    getPathByType(pageType) {
        return {
            [ModuleTypes_1.PageType.Advertisement]: constants_1.ROUTES.CONTENT.EDIT_ADVERTISEMENT,
            [ModuleTypes_1.PageType.Content]: constants_1.ROUTES.CONTENT.EDIT_CONTENT,
            [ModuleTypes_1.PageType.Quiz]: constants_1.ROUTES.CONTENT.EDIT_QUIZ,
            [ModuleTypes_1.PageType.Webinar]: constants_1.ROUTES.CONTENT.EDIT_WEBINAR
        }[pageType];
    }
}
exports.default = new PageUtil();
